import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslate } from 'shared/helper/translate';
import { parseValidators } from '../util';
import FormRow from './FormRow';
import CommonSelect from './CommonSelect';
var Select = function Select(_ref) {
  var description = _ref.description,
    label = _ref.label,
    messages = _ref.messages,
    name = _ref.name,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    validators = _ref.validators,
    required = _ref.required,
    _ref$isClearable = _ref.isClearable,
    isClearable = _ref$isClearable === void 0 ? false : _ref$isClearable,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? {
      value: ''
    } : _ref$defaultValue,
    filterOption = _ref.filterOption,
    noOptionsMessage = _ref.noOptionsMessage,
    _ref$onChange = _ref.onChange,
    customOnChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    optionComponent = _ref.optionComponent,
    options = _ref.options,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    sort = _ref.sort,
    selectStyles = _ref.selectStyles;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  return /*#__PURE__*/React.createElement(FormRow, {
    messages: messages,
    required: typeof required !== 'undefined' ? required : !!validators,
    name: name,
    label: label,
    styles: styles,
    description: description
  }, /*#__PURE__*/React.createElement(Controller, {
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
        _onChange = _ref2$field.onChange,
        onBlur = _ref2$field.onBlur,
        value = _ref2$field.value,
        name = _ref2$field.name;
      return /*#__PURE__*/React.createElement(CommonSelect, {
        isClearable: isClearable,
        filterOption: filterOption,
        name: name,
        noOptionsMessage: noOptionsMessage ? t(noOptionsMessage) : '',
        onBlur: onBlur,
        onChange: function onChange() {
          customOnChange.apply(void 0, arguments);
          return _onChange.apply(void 0, arguments);
        },
        optionComponent: optionComponent,
        options: options,
        placeholder: t(placeholder),
        readOnly: readOnly,
        sort: sort,
        value: value,
        selectStyles: selectStyles
      });
    },
    defaultValue: defaultValue,
    name: name,
    control: control,
    rules: parseValidators({
      messages: messages,
      validators: validators
    })
  }));
};
export default Select;